/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Input } from '@piggytechng/component-library';
import { formatToNaira, OverideButtonStyle, OverideInputStyle } from '../../helpers/utils';
import ModalExecuteAction from './ModalExecuteAction';
import useProcessor from '../../hooks/useProcessor';

function ModalUpdateMinimumBalanceThreshold({ modalIsOpen, setIsOpen, data, action }: ModalProps) {
  const [showActionModal, setShowActionModal] = useState(false);
  const { updateMinimumBalanceThreshold, isLoading } = useProcessor();

  function closeModal() {
    if (isLoading) return;
    setIsOpen(false);
  }

  const handleSubmit = () => {
    if (!rawAmount) {
      Alert.error('Please enter a valid minimum balance threshold');
      return;
    }

    updateMinimumBalanceThreshold(data?.provider, Number(rawAmount), () => {
      Alert.success('Minimum balance threshold updated successfully');
      closeModal();
      action && action();
    }).catch(() => {
      setShowActionModal(false);
      setIsOpen(true);
    });
  };

  const [form, setForm] = useState({
    amount: '',
  });

  useEffect(() => {
    if (modalIsOpen) {
      setForm({
        amount: data?.minimumBalanceAlertThreshold || '',
      });
    }
  }, [modalIsOpen]);

  const rawAmount = useMemo(() => {
    // remove naira symbol and commas
    const res = Number(form.amount.replace(/,/g, '').replace('₦', '')).toFixed(2);
    // it has no decimal places so we have to convert to kobo
    if (res.toString().indexOf('.') === -1) {
      return Number(res) * 100;
    } else {
      // already in kobo so we just need to remove the decimal point
      return Number(res.toString().replace('.', ''));
    }
  }, [form.amount]);

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <div className={`modal-processor`}>
          <div className="modal-processor__header">
            <h2>Configure Alert</h2>
            <button onClick={closeModal}>&times;</button>
          </div>
          <span className="modal-processor__sub-text">
            Set the Minimum Balance Alert Threshold for <b>{data?.name}</b> Processor
          </span>

          <form
            className="modal-processor__body"
            onSubmit={(e) => {
              e.preventDefault();
              setShowActionModal(true);
              setIsOpen(false);
            }}
          >
            <Input
              {...OverideInputStyle}
              labelStyle={{
                color: '#666766',
              }}
              label="Minimum Balance Alert Threshold"
              value={form.amount ? formatToNaira(Number(rawAmount) / 100) : ''}
              onChange={(e) => setForm({ ...form, amount: e.target.value })}
            />

            <div className="modal-processor__actions">
              <button className="modal-processor__actions-reject" type="button" onClick={() => closeModal()}>
                Cancel
              </button>

              <Button {...OverideButtonStyle} className="modal-processor__actions-resolve" type="submit">
                Confirm
              </Button>
            </div>
          </form>
        </div>
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showActionModal}
        isLoading={isLoading.updateMinimumBalanceThreshold}
        setIsOpen={setShowActionModal}
        text="update the minimum balance threshold?"
        action={() => handleSubmit()}
        actionColor="#1734CA"
        buttonText="Update"
      />
    </>
  );
}

export default ModalUpdateMinimumBalanceThreshold;
